import { effects, registerEventHandler } from 'reffects';
import { ACCELERATED_DELIVERY } from 'components/UnifiedCampaignForm/DeliveryForm/constants';
import { globals, http, queryParams } from 'reffects-batteries';
import { state } from 'reffects-store';

export function registerBudgetFormEvents() {
    registerEventHandler(
        'UPDATE_CAMPAIGN_BUDGET_TYPE',
        function updateCampaignBudgetType(_, { isDaily }) {
            if (isDaily) {
                return effects.dispatch('UPDATE_CAMPAIGN_FORM', {
                    isDaily,
                    deliveryMethod: ACCELERATED_DELIVERY,
                });
            }
            return effects.dispatch('UPDATE_CAMPAIGN_FORM', {
                isDaily,
            });
        }
    );

    registerEventHandler(
        'INITIALIZE_CAMPAIGN_CURRENT_COST',
        ({
            queryParams: { campaign: campaignId },
            globals: {
                trovitData: {
                    source: { countryId },
                },
            },
        }) => {
            const campaignUid = `${countryId}_${campaignId}`;
            return {
                ...http.get({
                    url: `/index.php/api/campaigns/${campaignUid}/monthly-cost`,
                    successEvent: ['REQUEST_CAMPAIGN_CURRENT_COST_SUCCESS'],
                    errorEvent: ['REQUEST_CAMPAIGN_CURRENT_COST_FAILED'],
                }),
            };
        },
        [queryParams.get(['campaign']), globals.get('trovitData')]
    );

    registerEventHandler(
        'REQUEST_CAMPAIGN_CURRENT_COST_SUCCESS',
        (_, [apiResponsePayload]) => {
            const {
                data: { monthlyCost },
            } = apiResponsePayload;
            return {
                ...state.set({
                    monthlyCost,
                }),
            };
        }
    );

    registerEventHandler('REQUEST_CAMPAIGN_CURRENT_COST_FAILED', () => {});
}
